import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMobileOS, storeUrlFor } from '../constants/app';
import styles from './AppRedirectPage.module.css';
import Logo from '../components/Logo';

/**
 * QR·짧은 링크 전용 착지점(/app).
 * OS를 판별해 해당 스토어로 즉시 보내고, 데스크톱처럼 판별이 안 되면 소개 페이지로 넘긴다.
 *
 * 클라이언트 리다이렉트라 아주 짧게 이 화면이 스친다. 서버(Vercel) 단에서
 * User-Agent로 302를 주면 더 빠르지만, 그건 호스팅 설정이 필요하다.
 */
export default function AppRedirectPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const url = storeUrlFor(getMobileOS());
    if (url) {
      // replace: 스토어에서 뒤로가기를 눌렀을 때 이 화면으로 되돌아오지 않게
      window.location.replace(url);
    } else {
      navigate('/download', { replace: true });
    }
  }, [navigate]);

  return (
    <div className={styles.page}>
      <p className={styles.logo}><Logo height={26} /></p>
      <p className={styles.text}>앱 스토어로 이동 중이에요…</p>
    </div>
  );
}
